import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { ChevronRight, Folder } from "lucide-react";
import { FolderBranchLine } from "../FolderBranchLine";
import { PlanRowActionsMenu } from "../PlanRowActionsMenu";
import type { FolderRowProps } from "./types";

export const FolderRow = ({
  folder,
  planCount,
  isOpen,
  containsSelectedPlan,
  onToggle,
  actionItems,
}: FolderRowProps) => {
  const { t } = useTranslation();

  return (
    <li className="pl-2">
      <button
        type="button"
        aria-expanded={isOpen}
        onClick={() => onToggle(folder.id)}
        className={clsx(
          "group w-full rounded-l-md border-r-2 px-2 py-1.5 text-left text-sm font-medium transition-colors",
          containsSelectedPlan && !isOpen
            ? "bg-blue-50 text-blue-700 border-blue-600"
            : "text-gray-800 hover:bg-gray-50 border-transparent",
        )}
      >
        <span className="flex items-start gap-1.5">
          <ChevronRight
            size={16}
            className={clsx(
              "mt-0.5 flex-shrink-0 text-gray-400 transition-transform",
              isOpen && "rotate-90",
            )}
          />
          <Folder size={16} className="mt-0.5 flex-shrink-0 text-gray-500" />
          <span className="min-w-0 flex-1 break-words">{folder.name}</span>
          {/* Plan count hidden for now:
          <span className="mt-0.5 flex-shrink-0 text-xs text-gray-500">
            {planCount}
          </span> */}
          {actionItems.length > 0 && (
            <PlanRowActionsMenu
              triggerTitle={t("smartSurveyor.folders.menu")}
              items={actionItems}
            />
          )}
        </span>
      </button>
      {isOpen && planCount === 0 && (
        <div className="relative ml-4 pl-4">
          <FolderBranchLine branch="last" />
          <p className="pb-1 pl-1 pt-2 text-xs italic text-gray-500">
            {t("smartSurveyor.folders.emptyFolder")}
          </p>
        </div>
      )}
    </li>
  );
};
